import * as actionTypes from '../../constants/ActionTypes/Dashboard';

const initialState = {
    deviceInfo: {},
    loading: false,
    error: "",
    success: false
}

const DashboardDeviceInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DASHBOARD_DEVICE_INFO_CALL_INIT:
            return {
                ...state,
                loading: true
            }
        case actionTypes.DASHBOARD_DEVICE_INFO_CALL_SUCCESS:
            return {
                ...state,
                deviceInfo: action.deviceInfo,
                loading: false,
                success: true
            }
        case actionTypes.DASHBOARD_DEVICE_INFO_CALL_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message
            }
        case actionTypes.RESET_DASHBOARD_DEVICE_INFO_CALL:
            return {
                ...state,
                error: '',
                deviceInfo: {},
                success: false,
                loading: false
            }
        default:
            return { ...state };
    }
}

export default DashboardDeviceInfo;